import { useState, useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Container, Grid, Card, CardContent, Divider } from "@material-ui/core";

import AutoCompleteField from "components/_refactor/fields/autocomplete";
import BigNumberCard from "components/_refactor/card/big-number";
import HeaderClientes from "components/_refactor/headers/clients";
import PeriodField from "components/_refactor/fields/period-field";
import FilterCard from "components/_refactor/filter-card";
import StructureFields from "components/_refactor/fields/structure";
import InputText from "components/_refactor/text/input";
import LoadingData from "components/Loading/LoadingData";
import Snackbar from "components/Alerts/Snackbar";
import TableRetireNaLoja from "./components/TableRetireNaLoja";

import Api from "lib/api/httpRequestHelper";
import MaskAndValid from "utils/maskAndValid";
import UtilsFncs from "utils/UtilsFncs";
import { IsMobile, IsMobile900, IsSmall } from "utils/is-mobile";
import {
  CheckCircle,
  LocalShipping,
  Schedule,
  Warning,
} from "@mui/icons-material";

const dataHoje = new Date().toISOString().slice(0, 10);

const statusOption = [
  {
    value: "TODOS",
    name: "Todos",
    id: 0,
  },
  {
    value: "A",
    name: "Aguardando Coleta",
    id: 1,
  },
  {
    value: "C",
    name: "Com Problema",
    id: 2,
  },
  {
    value: "P",
    name: "Pendentes",
    id: 3,
  },
  {
    value: "R",
    name: "Retirados",
    id: 4,
  },
];

export default function RetireNaLoja() {
  const location = useLocation();

  const [showCardResultados, setShowCardResultados] = useState(false);
  const [status, setStatus] = useState(statusOption[0]);
  const [periodo, setPeriodo] = useState(null);
  const [periodoInicial, setPeriodoInicial] = useState(dataHoje);
  const [periodoFinal, setPeriodoFinal] = useState(dataHoje);
  const [numeroPedido, setNumeroPedido] = useState("");
  const [cpfClienteRetirante, setCpfClienteRetirante] = useState("");
  const [autoSearch, setAutoSearch] = useState(false);

  const [resultados, setResultados] = useState(null);
  const [pesquisando, setPesquisando] = useState(false);

  const [statusPesquisado, setStatusPesquisado] = useState(statusOption[3]);

  const [openErro, setOpenErro] = useState(false);
  const [msgErro, setMsgErro] = useState("");

  const [openInfo, setOpenInfo] = useState(false);
  const [msgInfo, setMsgInfo] = useState("");

  const [structureFilters, setStructureFilters] = useState({});
  const [structureLoading, setStructureLoading] = useState([]);
  const [clearFilters, setClearFilters] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [hasNoBrand, setHasNoBrand] = useState(false);
  const [hasNoStore, setHasNoStore] = useState(false);

  const [totalRegisters, setTotalRegisters] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(25);
  const [refreshPage, setRefreshPage] = useState(false);

  const [cardsData, setCardsData] = useState({
    coleta: 0,
    pendentes: 0,
    retirados: 0,
    comProblema: 0,
  });
  const [loadingCards, setLoadingCards] = useState(false);

  const isSmall = IsSmall();
  const isMobile900 = IsMobile900();
  const isMobile = IsMobile();

  const itemXS = isMobile ? 12 : isMobile900 ? 6 : 3;
  const itemSM = isMobile ? 12 : isSmall ? 6 : 3;

  const handleCloseErro = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenErro(false);
  };

  const handleCloseInfo = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenInfo(false);
  };

  const handleClearFilters = () => {
    setClearFilters(true);
    setPesquisando(true);
    setStructureLoading(true);
    setStatus(statusOption[1]);
    setNumeroPedido("");
    setCpfClienteRetirante("");
    setPeriodoInicial(dataHoje);
    setPeriodoFinal(dataHoje);
    setPeriodo("30");
    setPesquisando(false);
    setStructureLoading(false);
  };

  const handleStopSearching = () => {
    setCancelLoading(true);
    setPesquisando(false);
    setResultados(null);
  };

  const getCollectDataByStatus = async (status) => {
    const today = new Date().toISOString().slice(0, 10);
    const initialDate = new Date();
    initialDate.setDate(initialDate.getDate() - 180);
    const periodo = `&dtIni=${initialDate
      .toISOString()
      .slice(0, 10)}&dtFim=${today}`;

    return Api.get(
      "collect-in-store-order",
      "order",
      UtilsFncs.RestParamsComposer(
        {
          idMarca: structureFilters?.idMarca ?? "TODAS",
          idLoja: structureFilters?.idLoja,
        },
        `?status=${status}&${periodo}&total=true`
      ),
      true
    );
  };

  const getListCollectInStoreOrder = useCallback(
    async ({
      urlMarca,
      urlLoja,
      urlPedido,
      urlStatus,
      page = 1,
      sizePerPage = 25,
    }) => {
      setPesquisando(true);

      const date = new Date();
      date.setDate(date.getDate() - periodo);

      await Api.get(
        "collect-in-store-order",
        "order",
        UtilsFncs.RestParamsComposer(
          {
            ...structureFilters,
            idMarca: urlMarca ?? structureFilters?.idMarca ?? "TODAS",
            idLoja: urlLoja || structureFilters?.idLoja,
          },
          "?" +
            (urlPedido || numeroPedido
              ? "idPedido=" + (urlPedido || numeroPedido)
              : "") +
            (MaskAndValid.isNullOrEmpty(cpfClienteRetirante)
              ? ""
              : "&cpf=" + cpfClienteRetirante) +
            "&status=" +
            (urlStatus || status?.value) +
            ((urlStatus || status?.value) !== "P"
              ? `&dtIni=${periodoInicial}&dtFim=${periodoFinal}`
              : "") +
            `&page=${page - 1}` +
            `&pageSize=${sizePerPage ? sizePerPage : 25}`
        ),
        true
      )
        .then((value) => {
          setShowCardResultados(true);
          setResultados(value?.Result?.ListPedidos || []);
          setTotalRegisters(value?.Result?.TotalRegistros);
          setCurrentPage(page);
          setCurrentSizePerPage(sizePerPage);
          setPesquisando(false);
        })
        .catch((error) => {
          setMsgErro(
            "Ocorreu um erro ao buscar dados. Verifique os parâmetros informados."
          );
          setOpenErro(true);
          console.log(error);
          setShowCardResultados(false);
          setPesquisando(false);
          setResultados([]);
        });
    },
    [
      cpfClienteRetirante,
      numeroPedido,
      periodo,
      periodoFinal,
      periodoInicial,
      status,
      structureFilters,
    ]
  );

  const getCardsData = async () => {
    if (!structureFilters?.idLoja) {
      return;
    }

    setLoadingCards(true);

    try {
      const [
        aguardandoResponse,
        pendentesResponse,
        retiradosResponse,
        comProblemaResponse,
      ] = await Promise.all([
        getCollectDataByStatus("A"),
        getCollectDataByStatus("P"),
        getCollectDataByStatus("R"),
        getCollectDataByStatus("C"),
      ]);

      setCardsData({
        coleta: aguardandoResponse?.Result?.TotalStatus || 0,
        pendentes: pendentesResponse?.Result?.TotalStatus || 0,
        retirados: retiradosResponse?.Result?.TotalStatus || 0,
        comProblema: comProblemaResponse?.Result?.TotalStatus || 0,
      });
    } catch (error) {
      setCardsData({
        coleta: 0,
        pendentes: 0,
        retirados: 0,
        comProblema: 0,
      });
    } finally {
      setLoadingCards(false);
    }
  };

  async function pesquisar() {
    setRefreshPage(false);
    setShowCardResultados(false);
    setAutoSearch(false);
    setResultados(null);

    await Promise.all([
      getListCollectInStoreOrder({
        page: 1,
        sizePerPage: currentSizePerPage,
      }),
      getCardsData(),
    ]);

    setStatusPesquisado(status);
  }

  const handleVerifyRequiredInputs = () => {
    if (
      (structureFilters?.idLoja !== "" && structureFilters?.idLoja) ||
      numeroPedido ||
      cpfClienteRetirante
    ) {
      return pesquisar();
    } else {
      if (!structureFilters?.idLoja && !numeroPedido && !cpfClienteRetirante) {
        setHasNoStore(true);
      }
    }
  };

  const triggerAutoSearch = useCallback(
    async (idMarca, idLoja, idPedido, urlStatus) => {
      setShowCardResultados(false);
      setAutoSearch(false);
      setResultados(null);
      setPesquisando(true);

      setPeriodoInicial(dataHoje);
      setPeriodoFinal(dataHoje);
      setPeriodo("30");

      await Promise.all([
        getListCollectInStoreOrder({
          urlMarca: idMarca,
          urlLoja: idLoja,
          urlPedido: idPedido,
          urlStatus: urlStatus || "TODOS",
          page: 1,
          sizePerPage: currentSizePerPage,
        }),
        getCardsData(),
      ]);

      setStatusPesquisado(status);
      setPesquisando(false);
      setAutoSearch(true);
    },
    [getListCollectInStoreOrder, status]
  );

  useEffect(() => {
    if (location.search) {
      const { idMarca, idLoja, idPedido } = UtilsFncs.GetUrlSearchParams(
        location.search
      );
      if (
        (!MaskAndValid.isNullOrEmpty(idMarca) &&
          !MaskAndValid.isNullOrEmpty(idLoja)) ||
        idPedido
      ) {
        setNumeroPedido(idPedido);
        triggerAutoSearch(
          parseInt(idMarca, 10),
          parseInt(idLoja, 10),
          idPedido,
          "P"
        );
      }
    }
  }, [location.search]);

  useEffect(() => {
    if (structureFilters?.idMarca || numeroPedido || cpfClienteRetirante) {
      setHasNoBrand(false);
    }
    if (
      structureFilters?.idLoja !== "" ||
      numeroPedido ||
      cpfClienteRetirante
    ) {
      setHasNoStore(false);
    }

    if (
      structureFilters?.idMarca === null &&
      structureFilters?.idCanal === "" &&
      structureFilters?.idRepresentante === "" &&
      structureFilters?.idGrupoEconomico === "" &&
      structureFilters?.idLoja === ""
    ) {
      setClearFilters(false);
    }
  }, [
    structureFilters,
    pesquisando,
    structureLoading,
    numeroPedido,
    cpfClienteRetirante,
    periodoFinal,
    periodoInicial,
    periodo,
    status,
  ]);

  useEffect(() => {
    if (refreshPage) {
      handleVerifyRequiredInputs();
    }
  }, [refreshPage]);

  const CARDS_INFO = [
    {
      icon: <Schedule style={{ color: "blue" }} fontSize="medium" />,
      title: "Aguardando Coleta",
      value: cardsData.coleta,
      loading: loadingCards,
      status: "A",
    },
    {
      icon: <LocalShipping style={{ color: "orange" }} fontSize="medium" />,
      title: "Aguardando Retirada",
      value: cardsData.pendentes,
      loading: loadingCards,
      status: "P",
    },
    {
      icon: <CheckCircle style={{ color: "green" }} fontSize="medium" />,
      title: "Retirados",
      value: cardsData.retirados,
      loading: loadingCards,
      status: "R",
    },
    {
      icon: <Warning style={{ color: "red" }} fontSize="medium" />,
      title: "Com Problema",
      value: cardsData.comProblema,
      loading: loadingCards,
      status: "C",
    },
  ];

  return (
    <>
      <HeaderClientes section="Consulta Retire na Loja" subsection="Pedidos" />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <FilterCard
          handleSearch={handleVerifyRequiredInputs}
          disabled={
            pesquisando ||
            structureLoading.length > 0 ||
            structureFilters?.idLoja === ""
          }
          searching={pesquisando}
          handleClearFilters={handleClearFilters}
        >
          <StructureFields
            fieldsOrder={["economicGroup", "store"]}
            clearFilters={clearFilters}
            onStructureFieldsChange={setStructureFilters}
            disableAll={pesquisando}
            onStructureFieldsLoad={setStructureLoading}
            requiredFields={["store"]}
            hasNoBrand={hasNoBrand}
            hasNoStore={hasNoStore}
            handleSearch={handleVerifyRequiredInputs}
          />

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={itemXS}>
            <InputText
              label="Número do Pedido"
              value={numeroPedido}
              onChange={(e) => {
                setNumeroPedido(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleVerifyRequiredInputs();
                }
              }}
              disabled={pesquisando}
            />
          </Grid>

          <Grid item xs={itemXS}>
            <InputText
              label="CPF"
              value={cpfClienteRetirante}
              onChange={(e) => {
                setCpfClienteRetirante(MaskAndValid.maskCPF(e.target.value));
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleVerifyRequiredInputs();
                }
              }}
              disabled={pesquisando}
              placeholder="000.000.000-00"
            />
          </Grid>

          <Grid item xs={itemXS}>
            <AutoCompleteField
              label="Status"
              onChange={(newValue) => {
                if (newValue !== "all") {
                  setStatus(newValue);
                } else {
                  setStatus(statusOption[1]);
                }
              }}
              value={status}
              options={statusOption}
              disabled={pesquisando}
              optionLabelKey="name"
              optionIdKey="id"
            />
          </Grid>

          {status.value !== "P" && (
            <Grid item xs={periodo?.value === "Outros" ? "12" : itemXS}>
              <PeriodField
                label="Período"
                value={periodo}
                onChange={setPeriodo}
                initialDate={periodoInicial}
                finalDate={periodoFinal}
                setInitialDate={setPeriodoInicial}
                setFinalDate={setPeriodoFinal}
                disabled={pesquisando || status === "P"}
              />
            </Grid>
          )}
        </FilterCard>

        {!cancelLoading && (
          <>
            <Snackbar
              text={msgInfo}
              open={openInfo}
              autoHideDuration={6000}
              onClose={handleCloseInfo}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              severity="info"
              style={{ backgroundColor: "#5e72e4" }}
            />
            <Snackbar
              text={msgErro}
              open={openErro}
              autoHideDuration={6000}
              onClose={handleCloseErro}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              severity="error"
            />
          </>
        )}

        <Grid item xs={12}>
          <LoadingData
            searching={pesquisando}
            onClick={() => handleStopSearching()}
            label="Buscando dados..."
          />
        </Grid>

        <Card>
          <CardContent>
            <Grid container spacing={2}>
              {CARDS_INFO.map((card, index) => (
                <Grid item xs={itemSM} key={index}>
                  <BigNumberCard
                    icon={card.icon}
                    title={card.title}
                    value={card.value}
                    loading={card.loading}
                    onClick={async () => {
                      setStatus(
                        statusOption.find((s) => s.value === card.status)
                      );
                      await getListCollectInStoreOrder({
                        urlStatus: card.status,
                        page: 1,
                        sizePerPage: currentSizePerPage,
                      });
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>

        {resultados && resultados.length > 0 && (
          <TableRetireNaLoja
            dataTable={resultados}
            totalRegistros={totalRegisters}
            currentPage={currentPage}
            currentSizePerPage={currentSizePerPage}
            search={getListCollectInStoreOrder}
            autoSearch={autoSearch}
            statusConsulta={statusPesquisado?.value}
            setRefreshPage={setRefreshPage}
          />
        )}
      </Container>
    </>
  );
}
